import React from "react";
import logo from "../resources/blacklogo.png";

function VisitMap() {
  return (
    <section className="relative py-24 md:py-32 bg-zinc-950 text-white overflow-hidden">
      {/* Decorative gradient */}
      <div className="absolute inset-0 bg-grid-pattern bg-[size:50px_50px] opacity-[0.07]"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand-500/10 rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center">
          {/* Left: heading + info */}
          <div>
            <p className="text-zinc-400 text-sm md:text-base font-chivo mb-3 uppercase tracking-[0.3em]">
              No appointment required
            </p>
            <h2 className="font-chivo text-5xl md:text-7xl font-black leading-[0.95] tracking-tight mb-8">
              VISIT{" "}
              <span className="gradient-text">US</span>
            </h2>

            <div className="space-y-6 text-zinc-300">
              <a
                href="https://www.google.com/maps/place/BiniAutoRepairINC/@40.9515721,-73.8751458,15z/data=!4m2!3m1!1s0x0:0x58aeec725b7b64cb?sa=X&ved=1t:2428&ictx=111"
                target="_blank"
                rel="noreferrer"
                className="flex items-start gap-4 group hover:text-white transition-colors"
              >
                <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-brand-500 to-brand-800 flex items-center justify-center flex-shrink-0 shadow-glow group-hover:scale-110 transition-transform">
                  <i className="fa-solid fa-location-dot text-white"></i>
                </div>
                <div>
                  <div className="text-xs uppercase tracking-wider text-zinc-500 mb-1">
                    Address
                  </div>
                  <div className="font-montserrat">10 Eastman Pl</div>
                  <div className="font-montserrat">Yonkers, NY 10701</div>
                </div>
              </a>

              <a
                href="tel:+13475820864"
                className="flex items-start gap-4 group hover:text-white transition-colors"
              >
                <div className="w-12 h-12 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center flex-shrink-0 group-hover:border-brand-500/50 transition-colors">
                  <i className="fa-solid fa-phone text-brand-400"></i>
                </div>
                <div>
                  <div className="text-xs uppercase tracking-wider text-zinc-500 mb-1">
                    Phone
                  </div>
                  <div className="font-montserrat text-lg">
                    (347) 582-0864
                  </div>
                </div>
              </a>
            </div>

            <img
              src={logo}
              alt=""
              className="w-32 h-16 object-contain opacity-60 invert mt-10"
            />
          </div>

          {/* Right: map */}
          <div className="relative rounded-3xl overflow-hidden border border-white/10 shadow-2xl shadow-brand-900/20">
            <div className="absolute -inset-1 bg-gradient-to-br from-brand-500/50 to-transparent rounded-3xl blur-sm -z-10"></div>
            <iframe
              width="100%"
              height="520"
              frameBorder="0"
              title="map"
              scrolling="no"
              marginHeight="0"
              marginWidth="0"
              className="grayscale-[30%] hover:grayscale-0 transition-all duration-500"
              src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=BiniAutoRepairINC,%2010%20Eastman%20Pl,%20Yonkers,%20NY%2010701,%20United%20States+(Bini%20Autorepair%20INC)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
            >
              <a href="https://www.gps.ie/">gps tracker sport</a>
            </iframe>
          </div>
        </div>
      </div>
    </section>
  );
}

export default VisitMap;
